export default __webpack_public_path__ + "static/timeline-back-4279bfd40af400dc30c1a8d2818d9434.webp";